import React from 'react';
import Select from 'react-select';
import { reactLocalStorage } from 'reactjs-localstorage';
import { Button, FormControl, Table } from 'react-bootstrap';
import Papa from 'papaparse';
import Form from 'react-bootstrap/Form';

import ApiUiController from '../../controller/ApiUiController';
import FieldController from '../../controller/FieldController';
import Const from '../../util/Constants';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Config from '../../config/config';
import Header from '../../api/Headers';

class LeadImport extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inApiCall: false, isUpdate: false, automate: false, distribute: false,
      addOption: false, update: false, headers: [], updateFields: [],
      batch: 1, selections:[]
    };

    const query = new URLSearchParams(props.location.search);
    this.ModelNo = query.get('model') ? parseInt(query.get('model')) : 1;
    let model = null;
    if(Const.Lead === this.ModelNo) model = 'lead';
    if(Const.Contact === this.ModelNo) model = 'contact';
    else if(Const.Property === this.ModelNo) model = 'property';
    else if(Const.Project === this.ModelNo) model = 'project';
    else if(Const.ColdData === this.ModelNo) model = 'cold_data';

    this.code = reactLocalStorage.getObject(Const.LoggedInUser).default_code;
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models[model];
    this.fields = this.model.fields;
    if(Const.ColdData === this.ModelNo) {
      this.fields = {
        name: {
          field_key: 'name',
          field_type: 'text',
          label_name: 'Name',
          field_order: 1,
          visible: 1,
          editable: 1,
          status: 4,
        },
        phone_number: {
        field_key: 'phone_number',
        field_type: 'text',
        label_name: 'Phone',
        field_order: 1,    
        visible: 1,
        editable: 1,
        status: 4,
        validate: "^[0-9]{10}$",
        },
        email: {
        field_key: 'email',
        field_type: 'email',
        label_name: 'Email',
        field_order: 3,
        visible: 1,
        editable: 1,
        status: 4,
        validate: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
        },

      address: {
        field_key: 'address',
        field_type: 'text',
        label_name: 'Address',
        field_order: 4,
        visible: 1,
        editable: 1,
        status: 4,
      },
      remark: {
        field_key: 'remark',
        field_type: 'text',
        label_name: 'Remark',
        field_order: 5,
        visible: 1,
        editable: 1,
        status: 4,
      }
      };
    }

    this.options = this.models.user.options
      .filter((user) => user.status === Const.Active)
      .map((salesPerson) => ({
        label: salesPerson?.label,
        value: salesPerson?.id,
      }));

    this.cities = reactLocalStorage.getObject(Const.Cities);
    this.states = reactLocalStorage.getObject(Const.States);
    this.countries = reactLocalStorage.getObject(Const.Countries);

    const fields = FieldController.getFields(this.fields);
    this.fieldList = [];
    for(let i = 0; i < fields.length; i++) {
      if(fields[i].field_key === 'status'
        || fields[i].field_key === 'model'
        || fields[i].field_key === 'created_by' || fields[i].field_key === 'created_date'
        || fields[i].field_key === 'updated_by' || fields[i].field_key === 'updated_date' ) continue;
      this.fieldList.push({ value: fields[i], label: fields[i].label_name });
    }
    this.data = [];
    this.file = null;

    if(model === 'property') {
      this.fieldList.push({
        label: 'Owner Name',
        value: { fieldKey: 'contact~name', field_key: 'contact~name', field_type: 'text', visible: 1,  editable: 1 }
      });
      this.fieldList.push({
        label: 'Owner Phone',
        value: { fieldKey: 'contact~phone', field_key: 'contact~phone', field_type: 'phone', visible: 1,  editable: 1 }
      });
      //this.fieldList.push({
      //  label: 'Owner Email',
      //  value: { fieldKey: 'contact~email', field_key: 'contact~email', field_type: 'email', visible: 1,  editable: 1 }
      //});
    }

    this.formats = [
      { label: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
      { label: 'DD/MM/YYYY HH:mm:ss', value: 'DD/MM/YYYY HH:mm:ss' },
      { label: 'DD/MM/YYYY hh:mm:ss a', value: 'DD/MM/YYYY hh:mm:ss a' },
      { label: 'DD/MM/YY', value: 'DD/MM/YY' },
      { label: 'DD/MM/YY HH:mm', value: 'DD/MM/YY HH:mm' },
      
      { label: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
      { label: 'MM/DD/YYYY HH:mm:ss', value: 'MM/DD/YYYY HH:mm:ss' },
      { label: 'MM/DD/YYYY hh:mm:ss a', value: 'MM/DD/YYYY hh:mm:ss a' },
      { label: 'MM/DD/YY', value: 'MM/DD/YY' },
      { label: 'MM/DD/YY HH:mm', value: 'MM/DD/YY HH:mm' },

      { label: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
      { label: 'YYYY/MM/DD HH:mm:ss', value: 'YYYY/MM/DD HH:mm:ss' },
      { label: 'YYYY/MM/DD hh:mm:ss a', value: 'YYYY/MM/DD hh:mm:ss a' },
      { label: 'YY/MM/DD', value: 'YY/MM/DD' },
      { label: 'YY/MM/DD HH:mm', value: 'YY/MM/DD HH:mm' }
    ];
  }

  onChange = event => {
    const reader = new FileReader();
    reader.onload = async event => {
      const res = Papa.parse(event.target.result);
      if(res.data !== undefined && res.data !== null && res.data.length > 1) {
        const headers = [];
        this.data = res.data;
        if(res.data.length < 5001) {
          for(let i = 0; i < res.data[0].length; i++) {
            const key = res.data[0][i];
            const field = this.fieldList.find(field => key.toLowerCase().trim() === field.label.toLowerCase().trim());
            let format = '';
            if(field) {
              if(field.value.field_type === Const.DateTime) format = 'DD/MM/YYYY HH:mm:ss';
              else if(field.value.field_type === Const.Date) format = 'DD/MM/YYYY';
            }
            headers.push({ key, field, format, update: false });
          }
          this.setState({ ...this.state, inApiCall: false, headers: [ ...headers ] });
        } else {
          Util.showNotification('Failure', 'Import size should be less than 5000', 'danger');
          this.setState({ ...this.state, inApiCall: false, headers: [ ] });
        }
      } else this.setState({ ...this.state, inApiCall: false, headers: [ ] });
    };
    if(event.target.files.length !== 0) {
      this.setState({ ...this.state, inApiCall: true });
      this.file = event.target.files[0];
      reader.readAsText(event.target.files[0]);
    }
  }

  onDemoDownload = () => {
    let csv = '';
    this.fieldList.filter(field => field.value.visible && field.value.editable)
      .forEach(field => csv += (csv !== '' ? ',' : '') + field.label);
    const element = document.createElement('a');
    element.href = URL.createObjectURL(new Blob([csv], {type: 'text/plain'}));
    element.download = this.model.model_name + ' Upload Demo.csv';
    document.body.appendChild(element);
    element.click();
  }

  onSelectChange = (i, select) => {
    const headers = [ ...this.state.headers ];
    headers[i].field = select;

    if(select) {
      if(select.value.field_type === Const.DateTime) headers[i].format = 'DD/MM/YYYY HH:mm:ss';
      else if(select.value.field_type === Const.Date) headers[i].format = 'DD/MM/YYYY';
      else headers[i].format = '';
    } else headers[i].format = '';

    this.setState({ ...this.state, inApiCall: false, headers: [ ...headers ] });
  }

  onFormatChange = (i, select) => {
    const headers = [ ...this.state.headers ];
    headers[i].format = select;
    this.setState({ ...this.state, inApiCall: false, headers: [ ...headers ] });
  }

  onUpdateChange = (i, checked) => {
    const headers = [ ...this.state.headers ];
    headers[i].update = checked;
    this.setState({ ...this.state, inApiCall: false, headers: [ ...headers ] });
  }

  checkAll = checked => {
    const headers = [ ...this.state.headers ];
    for(let i = 0; i < headers.length; i++) {
      if(headers[i].field && !headers[i].field.value.fieldKey.includes('address~')) {
        headers[i].update = checked;
      }
    }
    this.setState({ ...this.state, inApiCall: false, headers: [ ...headers ] });
  }

  onSave = () => {

    if (this.ModelNo === Const.ColdData && (!this.state.selections || this.state.selections.length === 0)) {
      Util.showNotification('Error', 'Please select at least one Sales Executive for Cold Data import', 'danger');
      return;
    }
    this.setState({ ...this.state, inApiCall: true});
    new Promise(async (resolve, error) => {
      const medias = [{ ref: 0, model_no: 23, model_id: 0, type: 'json', size: this.file.size },
        { ref: 1, model_no: 23, model_id: 0, type: 'csv', size: this.file.size }];
      const files = [this.file, this.file];
      const resMedias = await new Promise(resolve => {
        fetch(Config.app.link + 'api/media/put-private', new Header('POST', medias))
        .then(res => {
          if(res.status === Const.Success200) { res.json().then(result => resolve(result)); }
          else { res.json().then(er => Util.showError(er)); }
        }).catch(er => Util.showError(er));
      });
      await new Promise(resolve => fetch(resMedias[0].signed,
        { method: 'PUT', body: files[resMedias[0].ref] }).then(res => resolve(res)));
      await new Promise(resolve => fetch(resMedias[1].signed,
        { method: 'PUT', body: files[resMedias[1].ref] }).then(res => resolve(res)));

      let mapping = this.state.headers.map(header => {
        return { key: header.key, field: header.field ? header.field.value.fieldKey : '',
          field_key: header.field ? header.field.value.field_key : '', 
          field_type: header.field ? header.field.value.field_type : '', 
          format: header.format ? header.format.value : '', update: header.update };
      });

      if(this.ModelNo === Const.ColdData) {
        mapping = {
          mapping,
          batch: this.state.batch,
          responsible_person: this.state.selections.map(item => item.value)
        };
      }
      
      const updateFields = this.state.headers.filter(header => header.field && header.update)
        .map(header => header.field.value.fieldKey);

      const auth = reactLocalStorage.get(Const.System);
      const user = reactLocalStorage.getObject(Const.LoggedInUser).id;
      const importJson = {
        id: 0, module: this.ModelNo, import_status: 1, auth, user, file_name: this.file.name,
        updateFields: updateFields,
        isUpdate: this.state.isUpdate,
        isAutomate: this.state.automate,
        isDistribute: this.state.distribute,
        isAddOption: this.state.addOption,
        mapping: JSON.stringify(mapping), timezone: new Date().getTimezoneOffset() ,
        import_file: resMedias[1].ref === 0 ? resMedias[0].id : resMedias[1].id,
        result_json: resMedias[0].ref === 1 ? resMedias[1].id : resMedias[0].id };

      await new Promise(resolve => {
        fetch(Config.app.link + 'api/import', new Header('POST', importJson))
        .then(res => {
          if(res.status === Const.Success200) { res.json().then(result => resolve(result)); }
          else { res.json().then(er => Util.showError(er)); }
        }).catch(er => Util.showError(er));
      });
			resolve();
		}).then(err => {
      if(err) {
        Util.showError(err);
        this.setState({ ...this.state, inApiCall: false});
      } else {
        this.setState({ ...this.state, inApiCall: false});
        this.props.navigate('/setting/import');
      }
    });
  }

  render() {
    const fields = this.state.headers.map((header, i) => 
      <tr key={`crm_field_${i}`}>
        <td>{header.key}</td>
        <td>
          <Select value={header.field} onChange={select => this.onSelectChange(i, select)}
            options={this.fieldList} isSearchable={true} isClearable={true} />
        </td>
        <td> 
          { header && header.field && (header.field.value.field_type === Const.Date || header.field.value.field_type === Const.DateTime)
            ? <Select value={header.format} onChange={select => this.onFormatChange(i, select)}
            options={this.formats} isSearchable={true} isClearable={true} />
            : '' }
        </td>
        { this.state.isUpdate ? 
          <td>
            { header.field && !header.field.value.fieldKey.includes('address~')
              ? <Form.Check onChange={event => this.onUpdateChange(i, event.target.checked)} checked={header.update} />
              : ' '
            }
          </td>
          : null
        }
      </tr>
    );

    return (
      <div className="sectionform">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-6">
              <p className="mb-0"><small> Click Here To Download Lead Format</small></p>
              <Button variant="success" onClick={this.onDemoDownload} className="pt-2 pb-2 ml-0 mr-0">Demo CSV</Button>
              <FormControl accept='.csv' type="file" onChange={this.onChange} className="pt-2 pb-2" />
              <p><small>Only CSV Format Supported</small></p>
            </div>
          </div>
          <ApiUiController inApiCall={this.state.inApiCall}>
            { this.ModelNo !== Const.ColdData
              ? <>
                <div className="row">
                  <div className="col-md-4 pb-3">
                      <Form.Check style={{display:'inline'}} onChange={event => this.setState({ ...this.state, isUpdate: event.target.checked })} 
                        checked={this.state.isUpdate}/>
                        <label>&nbsp;&nbsp;&nbsp;Update if found duplicate ?</label>
                  </div>
                  <div className="col-md-4 pb-3">
                      <Form.Check  style={{display:'inline'}} onChange={event => this.setState({ ...this.state, automate: event.target.checked })} 
                        checked={this.state.automate}/>
                        <label>&nbsp;&nbsp;&nbsp;Run Workflow Automation ?</label>
                  </div>
                  <div className="col-md-4 pb-3">
                      <Form.Check style={{display:'inline'}}  onChange={event => this.setState({ ...this.state, addOption: event.target.checked })} 
                        checked={this.state.addOption}/>
                        <label>&nbsp;&nbsp;&nbsp;Add option if not found ?</label>
                  </div>
                </div>  
                { this.ModelNo === Const.Lead
                ? <div className="row">
                    <div className="col-md-4 pb-3">
                        <Form.Check style={{display:'inline'}} onChange={event => this.setState({ ...this.state, distribute: event.target.checked })} 
                          checked={this.state.distribute}/>
                          <label>&nbsp;&nbsp;&nbsp;Run Lead Distribution ?</label>
                    </div>
                  </div>
                  : null
                }
              </>
              : 
              <div className="row">
                <div className="col-md-4 pb-3">
                  <Form.Group className="mt-3">
                    <Form.Label>Batch Size</Form.Label>
                    <FormControl
                      type="number"
                      maxLength={3}
                      min={1}
                      max={500}
                      value={this.state.batch}
                      onChange={event => this.setState({ ...this.state, batch: Number(event.target.value) })}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4 pb-3">
                  <Form.Group className="mt-3">
                    <Form.Label>Sales Executive <span style={{ color: 'red' }}>*</span></Form.Label>
                    <Select
                      value={this.state.selections}
                      onChange={selections => this.setState({ ...this.state, selections })}
                      options={this.options}
                      isDisabled={false}
                      isSearchable={true}
                      isClearable={true}
                      isMulti={true}
                      placeholder="Select at least one sales executive..."
                      required
                    />
                    
                  </Form.Group>
                </div>
              </div>
            }
            <div className="row">
              <div className="col-md-6 pb-3"><h3>Fields</h3></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered>
                  <thead>
                    <tr>
                      <th>CSV Field</th>
                      <th>CRM Field</th>
                      <th>Format</th>
                      { this.state.isUpdate ? 
                        <th><Form.Check onChange={event => this.checkAll(event.target.checked)} />Update</th> 
                        : null }
                    </tr>
                  </thead>
                  <tbody>{fields}</tbody>
                </Table>
              </div>
              { this.state.headers.length !== 0 &&
                <div className="col-md-12 text-center btnsend">
                  <Button variant="success" onClick={this.onSave}>Import</Button>
                </div>
              }
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(LeadImport);